
import { useEffect } from 'react';
import { useCartStore } from '@/stores/newCartStore';
import { supabase } from '@/integrations/supabase/client';

export const useNewCart = () => {
  const { 
    items,
    isLoading,
    initialize,
    addItem,
    removeItem,
    calculateTotal,
    cleanup
  } = useCartStore();

  useEffect(() => {
    console.log("Initialisation du panier...");
    initialize();

    // Mettre en place une souscription aux changements en temps réel
    const channel = supabase
      .channel('cart-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'cart_items'
        },
        () => {
          console.log("Changement détecté dans le panier, réinitialisation...");
          initialize();
        }
      )
      .subscribe((status) => {
        console.log("Status de la souscription:", status);
      });

    return () => {
      console.log("Nettoyage du panier et de la souscription...");
      cleanup();
      supabase.removeChannel(channel);
    };
  }, [initialize, cleanup]);

  return {
    cartItems: items,
    isLoading,
    addToCart: addItem,
    handleRemoveItem: removeItem,
    calculateTotal
  };
};
